






































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import clientRegisterService from '@/services/ClientRegisterService';
import CookieConsentService from '@/services/CookieConsentService';
import {UserRequest} from '@/models/UserRequest';
import userService from '@/services/UserService';

import {
  AnswerRequest,
  AnswerResponse,
  APIResponse,
  ClientStatus,
  QuestionResponse,
  QuestionTO,
  RegisterRefiDigitalRequest,
  RegisterRequest,
  RegisterResponse,
  TokenRequest,
  TokenResponse,
} from '@/models';
import VueRecaptcha from 'vue-recaptcha';
import _moment from 'moment';
import ApiError from '@/models/ApiError';
import ValidationHelper from '@/helpers/ValidationHelper';
import codeGenMetadata from '@/helpers/register-form';
import refiDigitalClientRegisterService from '@/services/RefiDigitalClienteRegisterService';
import {ToastOptions} from "vue-toastification/dist/types/src/types";
import {TYPE} from "vue-toastification/dist/types/src/ts/constants";

declare const document: any;

@Component({
  components: {
    VueRecaptcha,
  },
})
export default class RegisterBlocks extends Vue {
  public EMAIL_REMETENTE: string = process.env.VUE_APP_EMAIL_REMETENTE;
  public token: string = '';
  public question: QuestionTO | null = null;
  public tokenResponse: TokenResponse | null = null;

  public finishedRegister: boolean = false;
  public hasQuestion: boolean = false;
  public hasAnswer: boolean = false;
  public questionResponse: QuestionResponse | null = null;

  public mothersFirstName: string | null = null;
  public birthdayDay: number | null = null;
  public birthdayYear: number | null = null;
  public answerResponse: AnswerResponse | null = null;

  public acceptTermsAndConditions: boolean = false;
  public cellphone: string = '';
  public email: string = '';
  public confirmEmail: string = '';
  public password: string = '';
  public confirmPassword: string = '';
  public registerResponse: RegisterResponse | null = null;
  public name: string = '';
  public birthDate: string = '';
  public nickname: string = '';

  public isBusy: boolean = false;
  public nonClient: boolean = false;
  public errorMessage: string = '';
  public countClick: number = 0;
  public cookieConsentService: CookieConsentService = new CookieConsentService(codeGenMetadata);
  public acceptWhatsapp: boolean = true;

  private _tokenRecaptcha: string = '';
  public loginEmAndamento: boolean = false;
  public userResponse: RegisterResponse | any = null;
  public emailReSuccessfullySent: boolean = false;

  public validEmail(): boolean {
    const validEmail = ValidationHelper.email(this.email);
    if (!validEmail) {
      document.getElementById("email").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido.";
      this.isBusy = false;
      return false;
    }
    if (!this.validConfirmEmail()) {
      this.isBusy = false;
      return false;
    }
    return true;
  }

  public validConfirmEmail(): boolean {
    const email = ValidationHelper.email(this.confirmEmail);
    if (!email) {
      document.getElementById("email").focus();
      this.loginEmAndamento = false;
      this.errorMessage = "Endereço de e-mail inválido. (Confirme seu e-mail)";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (this.email != this.confirmEmail) {
      document.getElementById("emailConfirm").focus();
      this.errorMessage = "Verifique o e-mail cadastrado, os campos 'E-mail” e “Confirme seu e-mail” devem ser iguais.";
      this.showMessage(this.errorMessage);
      return false;
    }
    return true;
  }

  public checkStrengthPassword(password: string): boolean {
    const numeros = /([0-9])/;
    const alfabeto = /([a-zA-Z])/;
    const chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    if (password.length < 8) {
      this.errorMessage = "A senha deve ter no mínimo 8 caracteres.";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
    if (password.match(numeros) && password.match(alfabeto) && password.match(chEspeciais)) {
      return true;
    } else {
      this.errorMessage = "Senha média, insira um caracter especial, pelo menos 1 letra maiúscula ou minúscula e um número!";
      this.showMessage(this.errorMessage, 'error');
      return false;
    }
  }

  public privacyPolicyRoute: any = {
    name: 'privacy-policy',
    query: {
      source: 'register-blocks',
    },
  };

  /// NOVOS METODOS ///
  public recaptchaSiteKey: string = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  public cpf: string = '';

  public localErrors: ApiError[] = [];

  public reset() {
    this.cpf = '';
  }

  public validarCpf(cpf: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'cpf');
    const erro = { property: 'cpf', message: '' };

    if (cpf.length === 0) {
      erro.message = 'Informe um CPF.';
      this.localErrors.push(erro);
      return;
    }

    const v = ValidationHelper.cpf(cpf);
    if (v === false) {
      erro.message = 'O CPF informado é inválido.';
      this.localErrors.push(erro);
    }
  }

  public solicitarLogin(e: Event) {
    this.isBusy = true;

    this.localErrors = [];
    this.validarCpf(this.cpf);
    if (!this.acceptTermsAndConditions) {
      this.isBusy = false;
      this.errorMessage =
        'É necessário concordar com os termos e condições para se cadastrar.';
      return;
    }

    if (this.localErrors.length) {
      this.isBusy = false;
      return;
    }

    (this.$refs.recaptcha as VueRecaptcha).reset();
    (this.$refs.recaptcha as VueRecaptcha).execute();
  }

  public mensagemErro(input: string) {
    const errors = this.localErrors.filter((erro) => erro.property === input);
    return errors.length ? errors[0].message : '';
  }

  public possuiErros(input: string) {
    return this.localErrors.find((erro) => erro.property === input);
  }

  public recaptchaValidado(tokenRecaptcha: string) {
    this.loadQuestion(tokenRecaptcha);
  }

  /**
   * @param type
   * SUCCESS = "success",
   * ERROR = "error",
   * WARNING = "warning",
   * INFO = "info",
   * DEFAULT = "default"
   */
  public showMessage(message = '', type = 'info') {
    this.$toast.clear();
    const options: (ToastOptions & { type?: TYPE.INFO | undefined } | any) = {
      timeout: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.83,
      showCloseButtonOnHover: false,
      hideProgressBar: false,
      closeButton: "button",
      icon: true,
      rtl: false
    }
    switch (type) {
      case 'success' :  this.$toast.success(message, options); break;
      case 'error' : this.$toast.error(message, options); break;
      case 'warning' : this.$toast.warning(message, options); break;
      case 'info' : this.$toast.info(message, options); break;
    }
  }

  public showErrorMessage(message = '', error: any) {
    if (error.response && error.response.data && error.response.data.omniSpanId) {
      message += `\n\n OmniSpanId: ${error.response.data.omniSpanId}`;
    }    
    this.showMessage(message, 'error');
  }


  // FIM NOVOS METODOS ///

  public async loadQuestion(recaptcha: string) {
    (this.$refs.recaptcha as VueRecaptcha).reset();
    this.errorMessage = '';
    this.isBusy = true;

    const tokenRequest = {
      document: this.cpf,
      recaptchaResponse: recaptcha,
      clientId: localStorage.getItem('omni-keycloak-clientId'),
    } as TokenRequest;

    try {
      this.tokenResponse = await clientRegisterService.token(tokenRequest);
      if (
        this.tokenResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE
      ) {
        this.isBusy = false;
        this.errorMessage = 'Erro no CAPTCHA. Tente novamente.';
        return;
      } else if (this.tokenResponse.status === APIResponse.CLIENT_NOT_FOUND) {
        this.isBusy = false;
        this.nonClient = true;
        this.hasAnswer = true;
        return;
      } else if (
        this.tokenResponse.status === APIResponse.INSUFFICIENT_CLIENT_DATA
      ) {
        this.isBusy = false;
        this.errorMessage = 'Cliente não encontrado ou dados insuficientes.';
        return;
      } else if (
        this.tokenResponse.status === APIResponse.INVALID_CLIENT_STATUS
      ) {
        this.isBusy = false;
        this.errorMessage = this.getInvalidStatusErrorMessage(
          this.tokenResponse);
        return;
       }
      this.token = this.tokenResponse.token;
      this.questionResponse = await clientRegisterService.question(this.token);
      this.question = this.questionResponse.question;
      this.hasQuestion = this.questionResponse.status === APIResponse.SUCCESS;
      this.nonClient = false;
    } catch (error) {
      if (error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        this.errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
      } else {
        this.errorMessage = "Ocorreu um erro. Tente novamente mais tarde.";
      }
      this.showErrorMessage(this.errorMessage, error);   
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public async sendAnswer(e: Event) {
    this.isBusy = true;
    this.errorMessage = '';

    if (!this.birthdayDay || !this.birthdayYear || !this.mothersFirstName) {
      this.isBusy = false;
      this.errorMessage = 'Preencha todos os campos.';
      this.showMessage(this.errorMessage, 'error');
      return;
    } else if (this.birthdayYear && this.birthdayYear.toString().length < 4) {
      this.isBusy = false;
      this.errorMessage = 'Campo ano de nascimento deve ter 4 dígitos.';
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    const answerRequest = {
      birthdayDay: this.birthdayDay,
      birthdayYear: this.birthdayYear,
      mothersFirstName: this.mothersFirstName,
    } as AnswerRequest;
    
    try {
      this.answerResponse = await clientRegisterService.answer(
        answerRequest,
        this.token);
      if (this.answerResponse.status === APIResponse.INCORRECT_ANSWER) {
        this.isBusy = false;
        this.errorMessage = 'Dados incorretos.';
        this.showMessage(this.errorMessage, 'error');
        return;
      } else if (this.answerResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.errorMessage =
          'Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004 3500 (Capitais e Regiões Metropolitanas) 0800 701 3500 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 727 0885 - Atendimento para todos os produtos, 24 horas, 7 dias por semana';
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      this.hasAnswer = this.answerResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      this.errorMessage = 'Ocorreu um erro. Tente novamente mais tarde.';
      this.showErrorMessage(this.errorMessage, error);
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public async sendRegister(e: Event) {
    this.isBusy = true;
    this.errorMessage = '';

    if(this.nonClient && !this.name){
      document.getElementById("name").focus();
      this.isBusy = false;
      this.loginEmAndamento = false;
      this.errorMessage = "Preencha o campo (Nome).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(this.nonClient && !this.nickname){
      document.getElementById("nickname").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (Como deseja ser chamado).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.email){
      document.getElementById("email").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (E-mail).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(this.nonClient && !this.birthDate) {
      document.getElementById("data-nascimento").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (Data de Nascimento).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.cellphone){
      document.getElementById("telefone").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (Celular).";
      this.showMessage(this.errorMessage);
      return;
    } else if (!ValidationHelper.cellphone(this.cellphone)) {
      document.getElementById("telefone").focus();
      this.isBusy = false;
      this.errorMessage = "O celular informado é inválido.";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.password){
      document.getElementById("senha").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (Senha).";
      this.showMessage(this.errorMessage);
      return;
    }

    if(!this.confirmPassword){
      document.getElementById("confirmPassword").focus();
      this.isBusy = false;
      this.errorMessage = "Preencha o campo (Confirmar Senha).";
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.acceptTermsAndConditions) {
      this.errorMessage =
          'É necessário concordar com os termos e condições para se cadastrar.';
      this.showMessage(this.errorMessage);
      return;
    }

    if (!this.validEmail()) {

      return;
    }

    if (this.password !== this.confirmPassword) {
      this.isBusy = false;
      this.errorMessage =
        'As senhas não coincidem. Digite sua senha novamente.';
      this.showMessage(this.errorMessage);
      this.password = '';
      this.confirmPassword = '';
      return;
    }

    if (!this.checkStrengthPassword(this.password)) {
      this.isBusy = false;
      return;
    }

    if(this.localErrors && this.localErrors.length >= 1){
      this.errorMessage = this.localErrors[0]['message'] as string;
      this.showMessage(this.errorMessage, 'error');
      return;
    }

    try {

      let status: string;
      if(this.nonClient) {
        const registerRequest = {
          name: this.name.trim(),
          email: this.email,
          cellphone: Number(this.cellphone),
          birthDate: Date.parse(this.parseToDate(this.birthDate)),
          document: this.cpf,
          password: this.password,
          nickname: this.nickname,
          redirectUri: localStorage.getItem('omni-keycloak-redirectUri'),
          clientId: localStorage.getItem('omni-keycloak-clientId'),
          acceptSendMessage: this.acceptWhatsapp,
        } as RegisterRefiDigitalRequest;

        /**
         * @description Validação Data de Nascimento
         */
        if (!registerRequest.birthDate) {
          this.isBusy = false;
          document.getElementById("data-nascimento").focus();
          this.errorMessage = "Preencha corretamente o campo (Data de Nascimento).";
          this.showMessage(this.errorMessage, 'error');
          return;
        }

        /**
         * @description Validação da Idade
         */
        const date = new Date(registerRequest.birthDate);
        const currentDate = new Date();
        const age = currentDate.getFullYear() - date.getFullYear();
        if(age < 18){
          this.isBusy = false;
          document.getElementById("data-nascimento").focus();
          this.errorMessage = "Você precisa ser maior de idade para continuar com cadastro!";
          this.showMessage(this.errorMessage, 'error');
          return;
        }

        this.registerResponse = await refiDigitalClientRegisterService.register(registerRequest);
        status = this.registerResponse.status;

      } else {
        const registerRequest = {
          acceptNotifications: true,
          acceptTermsAndConditions: this.acceptTermsAndConditions,
          cellphone: this.cellphone,
          email: this.email,
          password: this.password,
          nickname: this.nickname,
          redirectUri: localStorage.getItem('omni-keycloak-redirectUri'),
          clientId: localStorage.getItem('omni-keycloak-clientId'),
        } as RegisterRequest;

        this.registerResponse = await clientRegisterService.register(registerRequest, this.token);
        status = this.registerResponse.status;
    }

    if (status === APIResponse.EMAIL_ALREADY_IN_USE) {
      this.isBusy = false;
      this.errorMessage = 'Não foi possível registrar o usuário pois o e-mail já está em uso.';
      this.showMessage(this.errorMessage);
      return;
    }

    this.finishedRegister = this.registerResponse.status === APIResponse.SUCCESS;
    
    } catch (error) {
      this.errorMessage = 'Não foi possível realizar o cadastro.';
      if (error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        this.errorMessage = "Esse CPF já possui cadastro no Portal da Omni, digite a senha cadastrada ou clique em esqueci minha senha.";
      }
      this.showErrorMessage(this.errorMessage, error);
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public getInvalidStatusErrorMessage(response: any): string {
    let errorMessage = '';
    const [responseMessage]: string[] = response.messages;

    const [_, status] = responseMessage.split(': ');

    switch (status) {
      case ClientStatus.REGISTERED:
        errorMessage = 'CPF já cadastrado no sistema.';
        break;

      case ClientStatus.BLOCKED:
        errorMessage =
          'Acesso bloqueado por divergência  na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento 08007013500 ou 4004-3500.';
        break;

      default:
        break;
    }

    return errorMessage;
  }

  @Watch('email')
  public watchEmail(data: string) {
    this.email = data.trim().toLowerCase();
  }

  @Watch('confirmEmail')
  public watchConfirmEmail(data: string) {
    this.confirmEmail = data.trim().toLowerCase();
  }

  @Watch('mothersFirstName')
  public watchMothersFirstName(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      (this.$refs.birthdayDayInput as HTMLInputElement).focus();
    }
  }

  @Watch('hasQuestion')
  public watchHasQuestion(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  @Watch('hasAnswer')
  public watchHasAnswer(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  public verifyUserTerms() {
    return this.$router.push({
        name: 'privacy-policy',
        query: { source: 'register-blocks' },
      });
  }

  public maxLength(event: Event, model: string, maxLength: number) {
    const element: HTMLInputElement | null = event.target as HTMLInputElement;
    const value = element.value;

    if (String(value).length > maxLength) {
      const newValue = String(value).substring(0, maxLength);
      Reflect.set(this, model, newValue);
    }
  }

  public parseToDate(date: string): string {
    const fomatedDate = _moment(date, 'DD/MM/YYYY').toString();
    return fomatedDate;
  }

  public async reSendEmail() {
    if (!this.validEmail()) return;
    const userRequest = {
      document: this.cpf,
      redirectUri: localStorage.getItem("omni-keycloak-redirectUri"),
      recaptchaResponse: localStorage.getItem("_grecaptcha"),
      clientId:
          localStorage.getItem("omni-keycloak-clientId") === "refi-digital"
              ? "refi-digital"
              : "acerto",
    } as UserRequest;
    try {
      this.userResponse = await userService.resendEmail(userRequest, this.token);
      if (this.userResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.errorMessage =
            "Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004 3500 (Capitais e Regiões Metropolitanas) 0800 701 3500 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 727 0885 - Atendimento para todos os produtos, 24 horas, 7 dias por semana";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if (this.userResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.loginEmAndamento = false;
        this.errorMessage =
            "Não foi possível registrar o usuário pois o e-mail já está em uso.";
        this.showMessage(this.errorMessage, 'error');
        return;
      }
      if(this.userResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE) {
        this.loginEmAndamento = false;
        this.errorMessage = "Erro no CAPTCHA. Tente novamente.";
        this.showMessage(this.errorMessage);
        return;
      }
      if (this.userResponse.status === APIResponse.SUCCESS) {
        // E-mail enviado com sucesso
        this.emailReSuccessfullySent = true;
      }
    } catch (error) {
      this.errorMessage = "Não foi possível enviar o e-mail, Por gentileza entre em contato com nossa Central de Relacionamento.";
      this.showErrorMessage(this.errorMessage, error);
    }
  }
}
